import recurrenceMasterTypes from './recurrenceMasterTypes';
import bookForTypes from './bookForTypes';
import attendeesTypes from './attendeesTypes';

export default {
  ...recurrenceMasterTypes,
  ...bookForTypes,
  ...attendeesTypes
};
